export {default as PolLogo} from "./pol-logo";
export {default as PolTextLogo} from "./pol-text-logo";
